import { hotRank } from "@/mocks/guaData";

export default function Hot() {
  const max = Math.max(...hotRank.map((h) => h.heat));
  return (
    <section id="hot" className="scroll-mt-28 bg-paper-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-2xl text-white">
              <i className="ri-hotspot-line" />
            </span>
            <div>
              <div className="mb-1 text-xs font-semibold tracking-[0.2em] text-primary-600">REALTIME RANKING</div>
              <h2 className="font-serif text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">实时热榜 · 正在刷屏的事</h2>
            </div>
          </div>
          <p className="flex items-center gap-2 text-sm text-stone-500">
            <span className="h-2 w-2 animate-pulse rounded-full bg-leaf-500" />
            榜单基于多平台公开阅读热度估算，每小时更新
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {hotRank.map((it, idx) => (
            <a
              key={it.title}
              href="#channel"
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-paper-200 bg-paper-50 p-3.5 transition hover:-translate-y-0.5 hover:border-primary-200 hover:bg-white"
            >
              <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-serif text-lg font-extrabold ${
                idx < 3 ? "bg-primary-500 text-white" : "bg-paper-200 text-stone-500"
              }`}>
                {idx + 1}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <p className="line-clamp-2 text-sm font-medium text-stone-800 transition group-hover:text-primary-700 md:text-[15px]">
                    {it.title}
                  </p>
                  <span className="flex shrink-0 items-center gap-1 text-[11px] font-semibold">
                    {it.trend === "up" && <i className="ri-arrow-up-line text-primary-500" />}
                    {it.trend === "down" && <i className="ri-arrow-down-line text-leaf-600" />}
                    {it.trend === "flat" && <i className="ri-subtract-line text-stone-400" />}
                    <span className={it.trend === "down" ? "text-leaf-600" : "text-stone-500"}>{it.heat}万</span>
                  </span>
                </div>
                <div className="mt-2 flex items-center gap-3">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">#{it.tag}</span>
                  <div className="h-1 flex-1 overflow-hidden rounded-full bg-paper-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
                      style={{ width: `${(it.heat / max) * 100}%` }}
                    />
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}